import { default as diff } from 'changeset';
import React from 'react';
import ReactDOM from "react-dom";
import DesignerSetting from '@app/DesignerSetting';
import {
    Button,
    Select,
    OldSwitch
} from '@app/form_components';
import { Option } from '@app/types';
import ContextMenuWidget from "../../ContextMenuWidget";
import UnitTestDialog from "../../dialogs/UnitTestDialog";
import _ from 'lodash';

const endpointOptions = Option.fromStrings(DesignerSetting.s.processEngineEndpoints);

export default class SessionPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTests: [],
            selectedMockSchemas: [],
            graphQLSchemas: [],
            useMockData: this.props.useMockData
        }
        this.handleSelectedMockSchemas = this.handleSelectedMockSchemas.bind(this); 
    }

    componentDidMount() {
        this.testSelectionUpdated();
        this.setState({graphQLSchemas: this.props.graphQLSchemas})
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.selectedTests) !== JSON.stringify(this.getSelectedTests())) {
            this.testSelectionUpdated();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        const schemasDiff = diff(nextProps.graphQLSchemas, this.state.graphQLSchemas);
        
        if (schemasDiff[0] && schemasDiff[0].key && schemasDiff[0].key.length > 0) {
            // remove any deleted schemas from selectedSchemas
            this.setState({graphQLSchemas: nextProps.graphQLSchemas});
            // update selected schemas state
            this.updateSchemaSelections();
        }
    }

    setConfig(key, value) {
        if(key === "useMockData") {
            this.props.useMockDataToggle(value);
        }
        this.props.handleSessionParams({target: {name: key, value: value}});
    }

    getConfig(key) {
        return this.props[key];
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    testSelectionUpdated() {
        this.setState({
            selectedTests: this.getSelectedTests()
        });
    }

    getSelectedTests() {
        return this.getDomSelf().find("#unit_test_collection option:selected").toArray().map(d => d.value);
    }

    updateSchemaSelections() {
        const selectedMockSchemas =  this.getDomSelf().find(".mockShema:checked").toArray().map(d => d.value);
        
        this.setState({selectedMockSchemas: selectedMockSchemas});
    }

    handleSelectedMockSchemas(e){
        const schemaId = e.currentTarget.id.split('schema-id-')[1];
        const checked = e.currentTarget.checked;
        let _selectedSchemas = _.cloneDeep(this.state.selectedMockSchemas);
         
        if(checked){ // add
            if(_selectedSchemas.indexOf(schemaId) === -1){
                _selectedSchemas.push(schemaId);
            } 
        } else { // remove
            _selectedSchemas = _selectedSchemas.filter(schema => schema !== schemaId);
        }

        this.setState({selectedMockSchemas: _selectedSchemas});
    }

    switchTab(tab) {
        $('.nav-tabs a[href="#' + tab + '"]').tab('show');
    }

    render() {
        const self = this;
        const sessionStarted = this.props.sessionStarted && !this.props.sessionEnded;
        const sessionEnded = this.props.sessionStarted && this.props.sessionEnded;
        const sessionReset = !this.props.sessionStarted;
        const testRunning = this.props.unitTestResults.length > 0;
        const replayLoaded = this.props.replayQueue.length > 0;
        return (
            <div className="session-runner">
                <ul className="nav nav-tabs">
                    <li className="nav-button active">
                        <a data-toggle="tab" href="#session">Session</a>
                    </li>
                    <div className="break">&nbsp;</div>
                    <li className="nav-button">
                        <a data-toggle="tab" href="#unit_tests">Unit Tests</a>
                    </li>
                </ul>

                <div className="tab-content">
                    <div id="session" className="tab-pane fade in active">
                        {sessionReset && <div>
                            <div className="item">
                                <label>Endpoint</label>
                                <span className="reset"><a href='#' onClick={event => {
                                    event.preventDefault();
                                    this.props.handleEndpoint(endpointOptions[0].value);
                                }}>Reset</a></span>
                            </div>
                            <div className="item">
                                <Select
                                    options={endpointOptions}
                                    onChange={this.props.handleEndpoint}
                                    value={this.props.endpoint}
                                />
                            </div>
                            <div className="status">
                                <div className={this.props.endpointHealthy ? "up" : "down"}/>
                                <span>Version: {this.props.endpointVersion ? this.props.endpointVersion : "Not available"}</span>
                            </div>
                            
                            <hr/>
                            
                            <div className="session-options">
                                <div className="item">
                                    <label>Channel</label>
                                    <Select
                                        options={this.props.channelOptions}
                                        value={this.props.sessionType}
                                        name="sessionType"
                                        onChange={this.props.handleChannelSelect}
                                    />
                                </div>

                                <div className="item">
                                    <label>Source</label>
                                    <input className="form-component"
                                        name="source"
                                        value={this.props.source}
                                        onChange={this.props.handleSessionParams}
                                        onBlur={this.props.handleSessionParams}
                                    />
                                </div>

                                <div className="item">
                                    <label>ANI</label>
                                    <input className="form-component"
                                        name="ani"
                                        value={this.props.ani}
                                        onChange={this.props.handleSessionParams}
                                        onBlur={this.props.handleSessionParams}
                                    />
                                </div>

                                <div className="item">
                                    <label>DNIS</label>
                                    <input className="form-component"
                                        name="dnis"
                                        value={this.props.dnis}
                                        onChange={this.props.handleSessionParams}
                                        onBlur={this.props.handleSessionParams}
                                    />
                                </div>

                                <div className="item">
                                    <label>Session ID</label>
                                    <input className="form-component"
                                        name="currentSessionId"
                                        value={this.props.currentSessionId ? this.props.currentSessionId : ""}
                                        onChange={this.props.handleSessionParams}
                                        onBlur={this.props.handleSessionParams}
                                        placeholder="Leave blank for auto-gen"
                                    />
                                </div>

                                <div className="item">
                                    <label>Mock Schemas</label>
                                    {this.state.graphQLSchemas.map(schema => {
                                        const schemaId = 'schema-id-' + schema.id;
                                        return <div className="item" key={schemaId}>
                                            <span><input type="checkbox" 
                                                className="mockSchema"
                                                id={schemaId}
                                                name={schema.name} 
                                                value={schema.id} 
                                                checked={this.state.selectedMockSchemas.indexOf(schema.id) !== -1} 
                                                onChange={this.handleSelectedMockSchemas}/>
                                                <label 
                                                    htmlFor={schemaId}
                                                    style={{fontWeight: 'normal', paddingLeft: '6px'}}
                                                    >{schema.name}</label>
                                            </span>
                                        </div>})}

                                </div>    
                            </div>
                            
                            <hr/>

                            <div className="item">
                                <Button
                                    label="Start Session"
                                    disabled={this.props.sendingRequest || !this.props.endpointIsPE}
                                    callback={() => {
                                        const selectedSchemas = this.state.selectedMockSchemas
                                        
                                        this.props.handleStartSession(false, selectedSchemas);
                                    }}
                                />
                            </div>
                            <hr/>
                            <div className="item">
                                <label>Replay</label>
                                <input type="file" style={{margin: "2px 10px"}} accept=".json"
                                       onChange={event => {
                                           const file = event.currentTarget.files[0];
                                           if (!file) return;
                                           if (event.currentTarget.files[0].type !== "application/json") return;
                                           const reader = new FileReader();
                                           reader.onload = (e) => {
                                               this.props.handleImport(e.target.result);
                                           };
                                           reader.readAsText(file);
                                       }}
                                />
                            </div>
                            {replayLoaded && <div className="item">
                                <div>{"Total Unit Tests: " + this.props.replayQueue.length}</div>
                                <div>
                                    <Button
                                        label="Replay"
                                        disabled={this.props.sendingRequest}
                                        callback={() => {
                                            this.props.handleStartSession(true);
                                            this.switchTab("session");
                                        }}
                                    />
                                </div>
                            </div>
                            }
                        </div>}
                        {(sessionStarted && !testRunning) && <div id="run-session">
                            <label>Continue after timeout</label>
                            <OldSwitch
                                label={this.props.secondsToResponse ? `You have ${this.props.secondsToResponse} seconds to response` : ""}
                                context={this}
                                valKey={"autoResponse"}
                                checked={this.props.autoResponse}
                            />
                            <br/>
                            {this.props.selectedIntents && this.props.selectedIntents.map((intent, idx) => {
                                return (
                                    <div key={"intent_" + idx}>
                                        <div>
                                            <div><label>{"Intent #" + (idx + 1)}</label></div>
                                            <Select
                                                options={this.props.intentOptions}
                                                name="intentName"
                                                value={intent.name}
                                                onChange={intent => this.props.handleIntentName(intent, idx)}
                                            />
                                        </div>
                                        <div>
                                            <div><label>Value</label></div>
                                            <input
                                                className="form-component"
                                                name="intentValue"
                                                list="recognitionVariables"
                                                type={this.props.selectedIntents[idx].type === "date" ? "date" : "value"}
                                                value={this.props.selectedIntents[idx].value}
                                                onChange={event => this.props.handleIntentValue(event.target.value, idx)}
                                            />
                                            {this.props.recognitionVariables.length > 0 &&
                                            <datalist id="recognitionVariables">
                                                {this.props.recognitionVariables.map((v, i) => <option
                                                    key={"recognitionVariables" + i}>{v}</option>)}
                                            </datalist>
                                            }
                                        </div>
                                        <br/>
                                    </div>
                                )
                            })
                            }
                            <div className="button-group">
                                <Button
                                    label="+"
                                    type={"small"}
                                    callback={() => {
                                        this.props.handleAddIntent()
                                    }}
                                    tint={"secondary"}
                                />
                                {this.props.selectedIntents.length > 1 && <Button
                                    label="Remove Last Intent"
                                    type={"small"}
                                    callback={() => {
                                        this.props.handleRemoveIntent()
                                    }}
                                    tint={"secondary"}
                                />}
                            </div>
                            <Button
                                label="Submit Intents"
                                disabled={this.props.sendingRequest || !this.props.selectedIntents[0].name}
                                callback={() => {
                                    this.props.handleRunIntent()
                                }}
                            />
                            <br/>
                            <label>Error</label>
                            <Select
                                options={this.props.errorOptions}
                                name="error-select"
                                onChange={this.props.handleErrorSelect}
                                value={this.props.selectedError}
                            />
                            <Button
                                label="Submit Error"
                                disabled={this.props.sendingRequest || !this.props.selectedError}
                                callback={() => {
                                    this.props.handleSubmitError()
                                }}
                                tint={"error"}
                            />
                            <br/>
                            <Button
                                label="End Session"
                                callback={() => {
                                    this.props.handleEndSession()
                                }}
                                tint={"warning"}
                            />
                        </div>
                        }
                        {(sessionEnded && !testRunning) && <p>Session Ended.</p>}
                        {sessionEnded && <Button
                            label="Clear Results & Start Over"
                            callback={() => {
                                this.props.handleStartOver()
                            }}
                            tint={"warning"}
                        />}
                        
                        {(!sessionReset && !testRunning) && <div className="linkContainer">
                            <a href='#' onClick={event => {
                                event.preventDefault();
                                window.apm.popup("Save Unit Tests",
                                    '<div class="unit_test_save_container"></div>',
                                    '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                                    '<button class="w2ui-btn primary add-button">Save</button> ',
                                    [
                                        ".unit_test_save_container",
                                        () => {
                                            ReactDOM.render(<UnitTestDialog/>, $(".unit_test_save_container").get(0));
                                            $(".w2ui-popup").find(".add-button").on("click", function () {
                                                document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                                self.switchTab("unit_tests");
                                            });
                                        
                                        }

                                    ], 500
                                );
                            }}>Save Unit Tests</a>
                            
                            <a href='#' onClick={event => {
                                event.preventDefault();
                                this.props.handleDownload("unitTests");
                            }}>Download Unit Tests</a>
                            
                            <a href='#' onClick={event => {
                                event.preventDefault();
                                this.props.handleDownload("inputs");
                            }}>Download Inputs/Prompts</a>
                        </div>}
                    </div>
                    <div id="unit_tests" className="tab-pane fade in">
                        {!testRunning && <div>
                            <div className="item">
                                <label>Unit Test Collection</label>
                                <select id="unit_test_collection" className="list-select" onChange={() => {
                                    this.testSelectionUpdated();
                                }} multiple>
                                    {this.props.unitTests.length > 0 && this.props.unitTests.map((item, idx) => {
                                        return <option key={idx} value={item.id} title={item.name} onContextMenu={e => {
                                            if (!this.state.selectedTests.some(t => t === e.target.value)) {
                                                this.getDomSelf().find("#unit_test_collection option:selected").prop("selected", false);
                                            }
                                            e.target.selected = "selected";
                                            this.testSelectionUpdated();
                                            const contextContainer = $(".context_menu");
                                            ReactDOM.render(
                                                <ContextMenuWidget
                                                    type="unitTest"
                                                    context={this.getSelectedTests()}
                                                    domContext={contextContainer}
                                                    absolute={true}
                                                    pos={{left: e.pageX, top: e.pageY}}/>,
                                                contextContainer.get(0)
                                            );
                                            e.preventDefault();
                                        }}>
                                            {item.name}
                                        </option>
                                    })}
                                </select>
                            </div>
                        </div>}
                        <OldSwitch
                                label={"Use Mock Data"}
                                context={this}
                                valKey={"useMockData"}
                                checked={this.props.useMockData}
                            />
                        {sessionReset && <div>
                            <div className="button-group">
                                <Button
                                    label="Run Selected"
                                    disabled={this.state.selectedTests.length === 0}
                                    callback={() => {
                                        this.props.handleRunTests(this.state.selectedTests)
                                    }}
                                />
                                <Button
                                    label="Run All"
                                    disabled={this.props.unitTests.length === 0}
                                    callback={() => {
                                        this.props.handleRunTests(this.props.unitTests.map(ut => ut.id))
                                    }}
                                />
                            </div>
                            
                            <br/>
                            <hr/>
                            <div className="item">
                                <label>Import</label>
                                <input type="file" style={{margin: "10px 0"}} accept=".json"
                                       onChange={event => {
                                           const input = event.target;
                                           const file = event.currentTarget.files[0];
                                           if (!file) return;
                                           if (event.currentTarget.files[0].type !== "application/json") return;
                                           const reader = new FileReader();
                                           reader.onload = (e) => {
                                               input.value = "";
                                               window.apm.popup("Save Unit Tests",
                                                   '<div class="unit_test_save_container"></div>',
                                                   '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                                                   '<button class="w2ui-btn primary add-button">Save</button> ',
                                                   [
                                                        ".unit_test_save_container",
                                                        
                                                        () => {
                                                            ReactDOM.render(<UnitTestDialog
                                                                tests={JSON.parse(e.target.result)}/>, $(".unit_test_save_container").get(0));
                                                            $(".w2ui-popup").find(".add-button").on("click", function () {
                                                                document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                                            });
                                                        }
                                                    ], 
                                                   500
                                               );
                                           };
                                           reader.readAsText(file);
                                       }}
                                />
                            </div>
                        </div>}
                        {!sessionReset && <Button
                            label="Clear Results & Start Over"
                            callback={() => {
                                this.props.handleStartOver()
                            }}
                            tint={"warning"}
                        />}
                        {(testRunning && !sessionReset) && <div>
                            <p>{sessionEnded ? "All tests completed." : "Tests running..."} ({this.props.unitTestResults.filter(utr => utr.failed > 0).length} of {this.props.unitTestResults.length} failed)</p>
                            <table className="table table-hover">
                                <thead>
                                <tr>
                                    <th>Unit Test</th>
                                    <th className="test-result">Results</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.props.unitTestResults.sort((a, b) => b.failed - a.failed).map(utr => {
                                    const result = utr.total === utr.passed + utr.failed ? (utr.failed ? "failed" : "passed") : "running";
                                    const progress = result === "running" ? ` (${Math.round((utr.passed + utr.failed) * 100 / utr.total)}%)` : "";
                                    return <tr
                                        className={utr.sessionId === this.props.currentSessionId ? "selected" : ""}
                                        key={utr.id} onClick={() => {
                                        this.props.handleShowTest(utr);
                                    }}>
                                        <td>{utr.name}</td>
                                        <td className={"test-result " + result}>{result + progress}</td>
                                    </tr>
                                })}
                                </tbody>
                            </table>

                        </div>}
                    </div>
                </div>
            </div>

        );
    }

};